export const loginClub = (state, data) => {
    if(data.token) {
        localStorage.setItem('admToken', data.token)
        state.idToken = data.token
    }

    state.status = 'authenticated'
    state.club_id = data.club_id
    state.usu_id = data.usu_id
    state.club_nombre = data.club_nombre
    state.rol = data.rol
    state.club_code = data.club_code
}

export const setSolicitudes = (state, data) => {
    state.solicitudes = data
}

export const setCompeticiones = (state, data) => {
    state.competiciones = data
}

export const setUsuarios = (state, data) => {
    state.usuariosClub = data
}

export const logout = (state) =>  {
    state.idToken = null
    state.status = 'not-authenticated'
    state.club_id = 0
    state.usu_id = 0
    state.club_nombre = ''
    state.rol = ''
    state.club_code = ''

    localStorage.removeItem('admToken')
}